import * as React from "react";
const HorizontalRatioSmall = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3,5 L15,5 C15.5522847,5 16,5.44771525 16,6 L16,13 C16,13.5522847 15.5522847,14 15,14 L3,14 C2.44771525,14 2,13.5522847 2,13 L2,6 C2,5.44771525 2.44771525,5 3,5 Z M3,6 L3,13 L15,13 L15,6 L3,6 Z" }));
HorizontalRatioSmall.displayName = "HorizontalRatioSmall";
var HorizontalRatioSmall_default = HorizontalRatioSmall;
export {
  HorizontalRatioSmall_default as default
};
